import { memo, useEffect } from 'react';
import PropTypes from 'prop-types';
import { BzButton } from '../components';
import { Container, Row, Col } from 'react-bootstrap';
import { useSelector, useDispatch } from 'react-redux';
import { TOAST_TIMER } from '../utils/global_variables';
import { toastConfig } from '../redux/actions/toast';
import FocusLock from 'react-focus-lock';

const BzToastMessage = ({ btnClickHandler = () => { } }) => {

    const dispatch = useDispatch();

    const { toasts } = useSelector(state => state?.toasts);

    useEffect(() => {
        toasts.forEach(toast => {
            if (toast?.autoDismiss) {
            const objTimeout = setTimeout(() => {
                dispatch(toastConfig({id:toast?.id}));
            }, toast?.timer || TOAST_TIMER);
            return () => clearTimeout(objTimeout);
        } else { }
        });
    }, [dispatch, toasts]);

    const handleCloseToast = (id) => {
        dispatch(toastConfig({ id: id }))
    }

    return (
        <>
            {
                /** 09/01/2024 Ajitesh: TOAST MESSAGE LAYOUT IF CALLED FOR EDIS  */
                toasts.map(toast => toast?.show &&
                    <div data-testid='toastmessage-popup' className={toast?.backdrop ? 'toastmessage-backdrop' : null}>
                        <Container fluid className={`${toast?.error ? 'toastmessage-card-error toastmessage-card-sm' : 'toastmessage-card toastmessage-card-md'} `} data-testid='toastmessage-card'>
                            <FocusLock disabled={!toast?.focusLock} >
                                {toast?.edisFlag ?
                                    (
                                        <Row className='g-0'>
                                            <Col md='auto' className='d-flex justify-content-center align-items-start me-2'>
                                                <div className='icon-28 icon-edis-authentication'></div>
                                            </Col>
                                            <Col>
                                                <Row className='g-0 mb-2'>
                                                    <Col md={11} className='d-flex justify-content-start align-self-center'>
                                                        <div className='font-regular font-size4 toastmessage-textcolor text-wrap'>eDIS Permission</div>
                                                    </Col>
                                                    <Col md={1} className='d-flex justify-content-end align-items-center'>
                                                        <div className='icon-14 icon-close icon-light' onClick={()=>handleCloseToast(toast.id)}></div>
                                                    </Col>
                                                </Row>
                                                <Row className='g-0 align-items-start'>
                                                    <Col md={7} className='d-flex justify-content-start align-items-center'>
                                                        <div className='font-regular font-size2 toastmessage-textcolor'>{toast?.message}</div> {/*Hari P: BT-107432 Breeze Alert UI Issue fixed and added class for styling purpuse 22-11-2023*/}
                                                    </Col>
                                                    <Col md='auto' className='d-flex justify-content-end align-items-center ms-auto'>
                                                        {
                                                            toast?.button?.length > 0 ?
                                                                <div className='d-flex'> {/*Hari P: BT-107432 Breeze Alert UI Issue fixed and added class for styling purpuse 22-11-2023*/}
                                                                    {
                                                                        toast?.button.map((btn, index) =>
                                                                            <BzButton className={`btn btn-sm text-truncate text-capitalize ${btn?.className}`} key={index}  onClick={btn?.onClickHandler ? btn?.onClickHandler?.bind(this, btn) : btnClickHandler?.bind(this, btn?.type)} type="button" disabled={btn?.bIsDisabled}>
                                                                                {btn?.btnName}
                                                                            </BzButton>
                                                                        )
                                                                    }
                                                                </div> : null
                                                        }
                                                    </Col>
                                                </Row>
                                                <Row className='g-0 mt-2'>
                                                    <Col className='d-flex justify-content-end align-items-center'>
                                                        <div className='font-regular font-size1 toastmessage-textcolor text-wrap'>You can access this later via Hamburger menu (<div className='icon-10 icon-hamburger icon-light'></div>) &gt; eDIS permission OR Portfolio</div>
                                                    </Col>
                                                </Row>
                                            </Col>
                                        </Row>
                                    ) :
                                    (
                                        <Row className='g-0'>
                                            {toast?.realTimeMsg ?
                                                <Col md={12} className='d-flex justify-content-start align-self-center'>
                                                    <div className='font-regular font-size4 toastmessage-textcolor text-wrap'>Real Time Trade Message:</div>
                                                </Col>
                                                : null}
                                            <Col className='d-flex justify-content-start align-items-center'>
                                                <div data-testid='toastmessage-message' className={`${toast?.error ? 'font-semibold font-size4' : 'font-regular font-size3'} toastmessage-textcolor text-wrap`}>{toast?.message}</div> {/*Hari P: BT-107432 Breeze Alert UI Issue fixed and added class for styling purpuse 22-11-2023*/}
                                            </Col>
                                            {
                                                toast?.button?.length > 0 ? <Col md={4} className='d-flex justify-content-end align-items-center'>

                                                    <div className='d-flex'> {/*Hari P: BT-107432 Breeze Alert UI Issue fixed and added class for styling purpuse 22-11-2023*/}
                                                        {
                                                            toast?.button.map((btn, index) =>
                                                                <BzButton data-testid={btn?.btnName.toLowerCase().includes('remove')?'toast-remove-button' : btn?.btnName.toLowerCase().includes('close')?'toast-close-button' : btn?.btnName.toLowerCase().includes('ok')?'toast-ok-button':`toast-${index}-button`} autoFocus={btn.autoFocus || index === 0} className={`btn btn-md text-truncate text-capitalize ${btn?.className}`} key={index} onClick={btn?.onClickHandler ? btn?.onClickHandler?.bind(this, btn) : btnClickHandler?.bind(this, btn?.type)} type="button" disabled={btn?.bIsDisabled}>
                                                                    {btn?.btnName}
                                                                </BzButton>
                                                            )
                                                        }
                                                    </div>
                                                </Col> : null
                                            }
                                        </Row>
                                    )}
                            </FocusLock>
                        </Container>
                    </div>)
            }
        </>
    );
};


export default memo(BzToastMessage);

BzToastMessage.propTypes = {
    btnClickHandler: PropTypes.func,
};